import { format, UniqueTruncatedTooltip } from '../../common/utils/formatter'

export const shipmentMaterialsTableColumns = [
  { Header: 'Material Code', accessor: 'productCode' },
  { Header: 'Size', accessor: 'sizeCode' },
  { Header: 'Division', accessor: 'divisionCode', Cell: format(UniqueTruncatedTooltip) },
  { Header: 'Total Units', accessor: 'quantity' },
  { Header: 'Delivery Note', accessor: 'deliveryNoteNumber', Cell: format(UniqueTruncatedTooltip) },
  { Header: 'Sales Order', accessor: 'salesOrderNumber', Cell: format(UniqueTruncatedTooltip) },
  {
    Header: 'Purchase Order',
    accessor: 'purchaseOrderNumber',
    Cell: format(UniqueTruncatedTooltip),
  },
  {
    Header: 'Customer Purchase Order',
    accessor: 'customerPurchaseOrderNumber',
    Cell: format(UniqueTruncatedTooltip),
  },
]
